// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekDropPreview-moduleCalendarGridWeekDropPreview__DZkew CalendarGridWeekBlock-moduleCalendarGridWeekBlock__A0xR4";
export { _1 as "CalendarGridWeekDropPreview" }
